module.exports = __webpack_public_path__ + "img/man.16b394b6.jpeg";